import { storage } from '@utils/browser';
import { minutes } from '@utils/milliseconds';

const getPublishingKey = (id: string | undefined) => `journey-publishing-${id ?? ''}`;

export const getIsPublishingInTheBackground = (journeyId: string | undefined) => {
  const key = getPublishingKey(journeyId);
  const value = storage.get(key);
  if (!value) return false;
  const timestamp = Number(value);
  if (Number.isNaN(timestamp)) {
    storage.remove(key);
    return false;
  }
  const twoMinutes = minutes(2);
  const hasRunLessThanTwoMinutes = Date.now() - timestamp < twoMinutes;
  if (!hasRunLessThanTwoMinutes) {
    storage.remove(key);
  }
  return hasRunLessThanTwoMinutes;
};

export const setPublishingInBackground = (journeyId: string) => {
  storage.set(getPublishingKey(journeyId), String(Date.now()));
};

export const clearPublishingInBackground = (journeyId: string) => {
  storage.remove(getPublishingKey(journeyId));
};

export const clearSearchParam = (key: string) => {
  const url = new URL(window.location.href);
  url.searchParams.delete(key);
  window.history.replaceState({}, '', url.toString());
};

export const setPreviewVersionParam = (versionShortId: string) => {
  const url = new URL(window.location.href);
  url.searchParams.set('previewVersion', versionShortId);
  window.history.replaceState({}, '', url.toString());
};

export const clearPreviewVersionParam = () => {
  clearSearchParam('previewVersion');
};

export const getPreviewVersionParam = (): string | null => {
  const url = new URL(window.location.href);
  return url.searchParams.get('previewVersion');
};
